import { createAction } from '@reduxjs/toolkit';

/** avatar-id and avatar-url map */
interface AvatarURLById {
  [avatarId: MongoId]: string;
}

export const fetchAvatars = createAction<MongoId | MongoId[]>('avatars/fetch');
export const setAvatars = createAction<AvatarURLById>('avatars/set');
